import type { ReactElement } from 'react'
import { Route } from 'react-router-dom'
import { AdminRoute, PlatformAdminRoute } from '../components'
import {
  AdminSettingsPage,
  LicenseActivationPage,
  LicenseExpirationReportPage,
  LicenseManagementPage,
  OrgCasesPage,
  OrgVelociraptorTemplatesPage,
  OrganisationManagementPage,
  PlatformSettingsPage,
  ReportsHubPage,
  UserManagementPage,
  VelociraptorSettingsPage,
} from '../pages'

export function adminProtectedRoutes(): ReactElement {
  return (
    <>
      <Route path="/org/cases" element={<AdminRoute><OrgCasesPage /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><UserManagementPage /></AdminRoute>} />
      <Route path="/admin/organisations" element={<AdminRoute><OrganisationManagementPage /></AdminRoute>} />
      <Route path="/admin/licenses" element={<AdminRoute><LicenseManagementPage /></AdminRoute>} />
      <Route path="/admin/activation" element={<AdminRoute><LicenseActivationPage /></AdminRoute>} />
      <Route path="/admin/reports" element={<AdminRoute><ReportsHubPage /></AdminRoute>} />
      <Route path="/admin/reports/license-expiration" element={<AdminRoute><LicenseExpirationReportPage /></AdminRoute>} />
      <Route path="/admin/settings" element={<AdminRoute><AdminSettingsPage /></AdminRoute>} />
      <Route path="/org/velociraptor-templates" element={<AdminRoute><OrgVelociraptorTemplatesPage /></AdminRoute>} />
      <Route path="/admin/velociraptor" element={<AdminRoute><VelociraptorSettingsPage /></AdminRoute>} />
      <Route path="/admin/platform" element={<PlatformAdminRoute><PlatformSettingsPage /></PlatformAdminRoute>} />
    </>
  )
}
